module.exports = __webpack_public_path__ + "static/media/product.fda8bb75.png";